"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationProvider = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const context_1 = require("../../context");
const util_1 = require("../../util");
const TranslationProvider = ({ availableLocales, defaultLocale, fetchTranslation, fallback = null, children, }) => {
    const [selectedLocale, setSelectedLocale] = (0, react_1.useState)((0, util_1.findClosestLocale)((0, util_1.getBrowserLocale)(), availableLocales, defaultLocale));
    const [localeData, setLocaleData] = (0, react_1.useState)({
        locale: '',
        messages: {},
    });
    const setLocale = (requestedLocale) => {
        setSelectedLocale((0, util_1.findClosestLocale)(requestedLocale, availableLocales, defaultLocale));
    };
    (0, react_1.useEffect)(() => {
        const fetchTranslations = () => __awaiter(void 0, void 0, void 0, function* () {
            const messages = yield fetchTranslation(selectedLocale);
            setLocaleData({
                locale: selectedLocale,
                messages: messages,
            });
        });
        fetchTranslations();
    }, [selectedLocale]);
    if (localeData.locale && localeData.messages) {
        return (React.createElement(context_1.TranslationContext.Provider, { value: { availableLocales, setLocale, locale: selectedLocale } },
            React.createElement(react_intl_1.IntlProvider, { locale: localeData.locale, messages: localeData.messages }, children)));
    }
    return React.createElement(React.Fragment, null, fallback);
};
exports.TranslationProvider = TranslationProvider;
